const FormSection = ({ children, highlighted = false, index, title }) => (
  <section
    className={`software-form-section ${
      highlighted ? "software-form-section--highlighted" : ""
    }`}
  >
    <h6 className="software-form-section__title">
      {index}. {title}
    </h6>
    {children}
  </section>
);

export default FormSection;
